<template>
    <div class="tooltip-wrapper" @mouseenter="startTracking" @mouseleave="stopTracking" @mousemove="updatePosition">
        <!-- Trigger element slot -->
        <slot></slot>

        <!-- Floating tooltip -->
        <transition name="fade">
            <div v-if="show" class="custom-tooltip text-wrap shadow" :style="tooltipStyle" ref="tooltip">
                <div v-if="isHtml" v-html="message"></div>
                <div v-else>{{ message }}</div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "CustomTooltip",
    props: {
        message: { type: String, required: true },
        background: { type: String, default: "#018672fe" },
        color: { type: String, default: "#ffffff" },
        fontSize: { type: String, default: "12px" },
        padding: { type: String, default: "0.5em 0.5em" },
        offset: { type: Number, default: 12 },
        backdropFilter: { type: String, default: "blur(5px)" },
        isHtml: {
            type: Boolean,
            default: false,
        },
        maxWidth: { type: String, default: "200px" }
    },
    data() {
        return {
            show: false,
            mouseX: 0,
            mouseY: 0
        }
    },
    computed: {
        tooltipStyle() {
            return {
                position: "fixed",
                top: `${this.mouseY + this.offset}px`,
                left: `${this.mouseX + this.offset}px`,
                backgroundColor: this.background,
                color: this.color,
                fontSize: this.fontSize,
                padding: this.padding,
                borderRadius: "0.5em",
                zIndex: "999999",
                pointerEvents: "none",
                maxWidth: this.maxWidth,
                lineHeight: "13px",
                backdropFilter: this.backdropFilter,
                WebkitBackdropFilter: this.backdropFilter, // important for Safari
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)"
            }
        }

    },
    methods: {
        startTracking() {
            this.show = true
        },
        stopTracking() {
            this.show = false
        },
        updatePosition(event) {
            const tooltipEl = this.$refs.tooltip
            const tooltipWidth = tooltipEl?.offsetWidth || 150
            const tooltipHeight = tooltipEl?.offsetHeight || 20
            const padding = this.offset - 15

            let x = event.clientX + padding
            let y = event.clientY + padding

            // Prevent tooltip from overflowing right edge
            if (x + tooltipWidth > window.innerWidth) {
                x = event.clientX - tooltipWidth - padding
            }

            // Prevent tooltip from overflowing bottom edge
            if (y + tooltipHeight > window.innerHeight) {
                y = event.clientY - tooltipHeight - padding
            }

            this.mouseX = x
            this.mouseY = y
        }
    }
}
</script>

<style scoped>
.tooltip-wrapper {
    cursor: pointer;
    display: inline-block;
    position: relative;
}

.custom-tooltip {
    transition: opacity 0.2s ease;
}

/* .custom-tooltip .title {
    color: rgb(229, 229, 229);
    font-weight: 700 !important;
    border-bottom: 0.5px solid white;
} */

/* Fade effect */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s ease-in-out;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
